module.exports = __webpack_public_path__ + "img/qr-code-02.f385d096.svg";